<template>
  <div v-if="createdBy" class="row mt-3">
    <div class="col text-start text-body-secondary">تم إضافة هذا العقار بواسطة: {{ createdBy }}</div>
  </div>
  <div v-if="dataRow && dataRow.deletedAt" class="row mt-3">
    <div class="col">
      <div class="alert alert-warning">هذا العقار تم حذفه بواسطة المالك بتاريخ {{ $shortDate(dataRow.deletedAt) }}</div>
    </div>
  </div>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header">
      <div class="row">
        <div class="col-12 col-sm-6 text-start">
          <div class="card-title mb-0">
            {{ cardTitle }}
          </div>
        </div>
        <div class="col-12 col-sm-6 text-end">
          <router-link v-if="dataRow" :to="`/properties/create?copyId=${dataRow.id}`" class="btn btn-outline-primary btn-sm ms-3">
            <i class="bi bi-copy me-1"></i> نسخ العقار
          </router-link>
          <button
            v-if="dataRow && isArchived"
            type="button"
            class="btn btn-success btn-sm ms-3"
            @click="restoreProperty"
          >
            <i class="bi bi-arrow-counterclockwise me-1"></i> استرجاع من الأرشيف
          </button>
          <button
            v-else-if="dataRow"
            type="button"
            class="btn btn-outline-secondary btn-sm ms-3"
            @click="archiveProperty"
          >
            <i class="bi bi-archive me-1"></i> أرشفة العقار
          </button>
        </div>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <mainLoader v-if="mainLoading" />
    <form v-else @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row steps-container">
          <div class="col" v-for="(title, index) in stepTitles" :key="index">
            <div class="steps" @click="jumbToStep(index + 1)">
              <span :class="{ active: step === index + 1, 'marketing-step': index === 9 }">
                <i v-if="index === 9" class="bi bi-megaphone-fill ms-1"></i>
                {{ title }}
                <small v-if="index === 9" class="marketing-step-count">3</small>
              </span>
            </div>
          </div>
        </div>
        <!-- owner type -->
        <div v-if="step == 1">
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label class="form-label" for="propertyProjectId">المشروع العقاري:</label>
              <select id="propertyProjectId" ref="projectsSelect" class="form-control" v-model="projectId" @change="setProject()" :disabled="Boolean(containerId)">
                <option :value="null">غير تابع لمشروع</option>
                <option v-for="project in projectsList" :key="project.id" :value="project.id">{{ project.title }}</option>
              </select>
              <div v-if="containerId" class="form-text">يتبع المشروع المحدد للعقار متعدد الوحدات تلقائياً.</div>
              <div v-else-if="projectId" class="form-text">تم اختيار العميل والعنوان من بيانات المشروع.</div>
              <router-link v-if="projectId && checkAccess('projects_read')" :to="`/projects/update/${projectId}`" class="d-inline-block mt-1">عرض المشروع</router-link>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-12 col-sm-6">
                <label class="form-label" for="">العميل:</label>
                <input type="text" class="form-control" placeholder="جوال العميل" @keyup="getClientData()" v-model="userMobile" :disabled="Boolean(projectId)">
              </div>
              <div class="col-12 col-sm-6">
                <loader v-if="userLoader" />
                <div v-if="userName">
                  <label class="form-label" for="">اسم العميل:</label>
                  <div>{{ userName }}</div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="mb-3">
            <label class="form-label" for="">نوع المالك:</label>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="ownerType" id="ownerType1" value="owner" v-model="ownerType">
              <label class="form-check-label" for="ownerType1">
                مالك
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="ownerType" id="ownerType2" value="agent" v-model="ownerType">
              <label class="form-check-label" for="ownerType2">
                وكيل
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="ownerType" id="ownerType3" value="broker" v-model="ownerType">
              <label class="form-check-label" for="ownerType3">
                وسيط عقاري
              </label>
            </div>
          </div>
          <div class="mb-3 form-check">
            <input id="crmChat" v-model="crmChat" class="form-check-input" type="checkbox">
            <label class="form-check-label" for="crmChat">
              يتم المحادثة عن طريق خدمة عملاء العقارية
            </label>
          </div>
          <div v-if="dataRow" class="mb-3">
            <label class="form-label" for="">مصدر الطلب:</label>
            <div>
              <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
              <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
              <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
              <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
              <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
              <span v-else class="text-muted">غير محدد</span>
            </div>
          </div>
        </div>
        <!-- owner data -->
        <div v-if="step == 2">
          <div class="mb-3">
            <label for="" class="form-label">رقم ترخيص الاعلان:</label>
            <input type="text" class="form-control" v-model="adLicenseNumber">
          </div>
          <!-- owner -->
          <div v-if="ownerType == 'owner'">
            <div class="mb-3">
              <label for="" class="form-label">صورة الصك:</label>
              <input type="file" class="form-control" @change="setReceiptImage($event.target.files)" multiple />
              <!-- <img v-if="uploadedReceipt" :src="MEDIA_URL+uploadedReceipt" class="img-thumbnail" style="max-width: 200px;" alt=""> -->
              <div v-for="(img, indx) in uploadedReceipt" :key="indx" class="m-2">
                <a v-if="img.extention == 'pdf'" :href="MEDIA_URL+img.path" target="_blank">PDF file</a>
                <img v-if="img.extention != 'pdf'" :src="MEDIA_URL+img.path" class="img-thumbnail" style="max-width: 200px;" alt="">
              </div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم الصك:</label>
              <input type="text" class="form-control" v-model="receiptNumber">
            </div>
            <!-- <div class="mb-3">
              <label for="" class="form-label">تاريخ الصك:</label>
              <input type="date" class="form-control" v-model="receiptDate">
            </div> -->
            <div class="mb-3">
              <label for="" class="form-label">رقم هوية المالك:</label>
              <input type="number" class="form-control" v-model="ownerIdentity">
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد المالك:</label>
              <input type="date" class="form-control" v-model="ownerDOB">
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم جوال المالك:</label>
              <input type="text" class="form-control" v-model="ownerMobile">
            </div>
          </div>
          <!-- agent -->
          <div v-if="ownerType == 'agent'">
            <div class="mb-3">
              <label for="" class="form-label">صورة الوكالة:</label>
              <input type="file" class="form-control" @change="setAgencyImage($event.target.files)" multiple />
              <div v-for="(img, indx) in uploadedAgencyImage" :key="indx" class="m-2">
                <a v-if="img.extention == 'pdf'" :href="MEDIA_URL+img.path" target="_blank">PDF file</a>
                <img v-if="img.extention != 'pdf'" :src="MEDIA_URL+img.path" class="img-thumbnail" style="max-width: 200px;" alt="">
              </div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم الوكالة:</label>
              <input type="text" class="form-control" v-model="agencyNumber">
            </div>
            <!-- <div class="mb-3">
              <label for="" class="form-label">تاريخ الوكالة:</label>
              <input type="date" class="form-control" v-model="agencyDate">
            </div> -->
            <div class="mb-3">
              <label for="" class="form-label">رقم الصك:</label>
              <input type="text" class="form-control" v-model="receiptNumber">
            </div>
            <!-- <div class="mb-3">
              <label for="" class="form-label">تاريخ الصك:</label>
              <input type="date" class="form-control" v-model="receiptDate">
            </div> -->
            <!-- <div class="mb-3">
              <label for="" class="form-label">رقم هوية المالك:</label>
              <input type="number" class="form-control" v-model="ownerIdentity">
            </div> -->
            <!-- <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد المالك:</label>
              <input type="date" class="form-control" v-model="ownerDOB">
            </div> -->
            <div class="mb-3">
              <label for="" class="form-label">رقم هوية الوكيل:</label>
              <input type="number" class="form-control" v-model="agentIdentity">
            </div>
            <!-- <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد الوكيل:</label>
              <input type="date" class="form-control" v-model="agentDOB">
            </div> -->
            <div class="mb-3">
              <label for="" class="form-label">رقم جوال الوكيل:</label>
              <input type="text" class="form-control" v-model="agentMobile">
            </div>
          </div>
          <!-- broker -->
          <div v-if="ownerType == 'broker'">
            <div class="mb-3">
              <label for="" class="form-label">رقم رخصة فال:</label>
              <input type="text" class="form-control" v-model="falLicense">
            </div>
            <div class="mb-3">
              <label for="" class="form-label">صورة الصك:</label>
              <input type="file" class="form-control" @change="setReceiptImage($event.target.files)" multiple />
              <!-- <img v-if="uploadedReceipt" :src="MEDIA_URL+uploadedReceipt" class="img-thumbnail" style="max-width: 200px;" alt=""> -->
              <div v-for="(img, indx) in uploadedReceipt" :key="indx" class="m-2">
                <a v-if="img.extention == 'pdf'" :href="MEDIA_URL+img.path" target="_blank">PDF file</a>
                <img v-if="img.extention != 'pdf'" :src="MEDIA_URL+img.path" class="img-thumbnail" style="max-width: 200px;" alt="">
              </div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم الصك:</label>
              <input type="text" class="form-control" v-model="receiptNumber">
            </div>
            <!-- <div class="mb-3">
              <label for="" class="form-label">تاريخ الصك:</label>
              <input type="date" class="form-control" v-model="receiptDate">
            </div> -->
            <!-- <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد المالك:</label>
              <input type="date" class="form-control" v-model="ownerDOB">
            </div> -->
            <!-- <div class="mb-3">
              <label for="" class="form-label">رقم جوال المالك:</label>
              <input type="text" class="form-control" v-model="ownerMobile">
            </div> -->
            <!-- <div class="mb-3">
              <label for="" class="form-label">رقم هوية الوكيل:</label>
              <input type="number" class="form-control" v-model="agentIdentity">
            </div> -->
            <!-- <div class="mb-3">
              <label for="" class="form-label">رقم الوكالة:</label>
              <input type="text" class="form-control" v-model="agencyNumber">
            </div> -->
            <!-- <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد الوكيل:</label>
              <input type="date" class="form-control" v-model="agentDOB">
            </div> -->
            <div class="mb-3">
              <label for="" class="form-label">رقم جوال الوكيل:</label>
              <input type="text" class="form-control" v-model="agentMobile">
            </div>
          </div>
          <div class="row">
            <div class="col"><hr></div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة هوية المالك:</label>
              <input type="file" class="form-control" @change="setIdentityImage($event.target.files)">
              <img v-if="uploadedIdentityImage" :src="MEDIA_URL+uploadedIdentityImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة رخصة البناء:</label>
              <input type="file" class="form-control" @change="setBuildingPermitImage($event.target.files)">
              <img v-if="uploadedBuildingPermitImage" :src="MEDIA_URL+uploadedBuildingPermitImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة شهادة الدفاع المدني:</label>
              <input type="file" class="form-control" @change="setDefenseCertificateImage($event.target.files)">
              <img v-if="uploadedDefenseCertificateImage" :src="MEDIA_URL+uploadedDefenseCertificateImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
          </div>
        </div>
        <!-- property data -->
        <div v-if="step == 3">
          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات الاساسية:</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">تصنيف العقار: <span class="req">*</span></label>
              <select class="form-control" v-model="category" @change="setTypesList">
                <option value="residential">سكني</option>
                <option value="commercial">تجاري</option>
                <option value="agricultural">زراعي</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الغرض من الإعلان: <span class="req">*</span></label>
              <select class="form-control" v-model="purpose">
                <option value="for_sale">للبيع</option>
                <option value="for_rent">للإيجار</option>
                <option value="for_investment">للإستثمار</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">السعر:</label>
              <input type="number" class="form-control" v-model="price">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">نوع العقار: <span class="req">*</span></label>
              <select ref="typesSelect" class="form-control" v-model="typeId" @change="setTypeFields">
                <option v-for="(row, index) in typesList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
          </div>
          <!-- Coupon field for property -->
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">كوبون الخصم (اختياري):</label>
              <div class="input-group">
                <input type="text" class="form-control" v-model="couponCode" placeholder="أدخل كود الخصم" :disabled="couponLoading">
                <button type="button" class="btn btn-outline-secondary" @click="validateCoupon()" :disabled="couponLoading || !couponCode">
                  <span v-if="couponLoading" class="spinner-border spinner-border-sm" role="status"></span>
                  <span v-else>تحقق</span>
                </button>
              </div>
              <div v-if="couponResult" class="mt-2">
                <div v-if="couponResult.status === 'success'" class="alert alert-success py-2 mb-0">
                  <i class="bi bi-check-circle me-1"></i>
                  تم تطبيق الكوبون: السعر الأصلي <strong>{{ couponResult.originalPrice?.toLocaleString() }}</strong> ←
                  السعر بعد الخصم <strong>{{ couponResult.priceAfterDiscount?.toLocaleString() }}</strong>
                </div>
                <div v-else class="alert alert-danger py-2 mb-0">
                  <i class="bi bi-x-circle me-1"></i> {{ couponResult.msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">وصف مختصر: <span class="req">*</span></label>
              <input type="text" class="form-control" v-model="title">
              <div v-if="dataRow" class="mt-3">
                <label for="" class="form-label">وصف مختصر (مترجم):</label>
                <div>{{ dataRow.titleEn }}</div>
              </div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الوصف: <span class="req">*</span></label>
              <textarea class="form-control" cols="5" v-model="description"></textarea>
              <div v-if="dataRow" class="mt-3">
                <label for="" class="form-label">الوصف (مترجم):</label>
                <div>{{ dataRow.descriptionEn }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات العنوان:</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المنطقة: <span class="req">*</span></label>
              <select class="form-control" v-model="regionId" @change="getCitiesList()" :disabled="Boolean(projectId || containerId)">
                <option v-for="(row, index) in regionsList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المدينة: <span class="req">*</span></label>
              <select ref="citiesSelect" class="form-control" v-model="cityId" @change="getNeighborhoodsList()">
                <option v-for="(row, index) in citiesList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الحي: <span class="req">*</span></label>
              <select ref="neighborhoodsSelect" class="form-control" v-model="neighborhoodId" @change="changeMapMarker">
                <option :value="null">غير محدد</option>
                <option v-for="(row, index) in neighborhoodsList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الشارع:</label>
              <input type="text" class="form-control" v-model="street">
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المساحة:</label>
              <input type="number" class="form-control" v-model="area">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الموقع على الخريطة:</label>
              <div ref="myMap" style="width: 100%; height: 350px;"></div>
              <div class="row pt-2">
                <div class="col">
                  <label for="" class="form-label">خط العرض - latitude</label>
                  <input type="number" class="form-control" step="0.000001" v-model="latitude" placeholder="latitude" @change="changeMarker()">
                </div>
                <div class="col">
                  <label for="" class="form-label">خط الطول - longitude</label>
                  <input type="number" class="form-control" step="0.000001" v-model="longitude" placeholder="longitude" @change="changeMarker()">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الواجهة:</label>
              <select ref="frontsSelect" v-model="frontId" class="form-control">
                <option :value="null">اختر الواجهه</option>
                <option v-for="f in frontsList" :value="f.id" :key="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات الإضافة:</div>
            </div>
          </div>

          <div class="row">
            <div v-if="currentTypeFields.indexOf('propertyType') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">نوع الساكن:</label>
              <select class="form-control" v-model="propertyType">
                <option value="singles">عزاب</option>
                <option value="families">عوائل</option>
              </select>
            </div>
            <div v-if="currentTypeFields.indexOf('buildNumber') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم المبنى:</label>
              <input type="string" class="form-control" v-model="buildNumber">
            </div>
            <div v-if="currentTypeFields.indexOf('floorsCount') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الطوابق:</label>
              <input type="number" class="form-control" v-model="floorsCount">
            </div>
            <div v-if="currentTypeFields.indexOf('floorNumber') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم الطابق:</label>
              <input type="number" class="form-control" v-model="floorNumber">
            </div>
            <div v-if="currentTypeFields.indexOf('apartmentNumber') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم الشقة:</label>
              <input type="number" class="form-control" v-model="apartmentNumber">
            </div>
            <div v-if="currentTypeFields.indexOf('roomsCount') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الغرف:</label>
              <input type="number" class="form-control" v-model="roomsCount">
            </div>
            <div v-if="currentTypeFields.indexOf('bathrooms') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الحمامات:</label>
              <input type="number" class="form-control" v-model="bathrooms">
            </div>
            <div v-if="currentTypeFields.indexOf('furnished') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مؤثث:</label>
              <select v-model="furnished" class="form-control">
                <option :value="true">نعم</option>
                <option :value="false">لا</option>
              </select>
            </div>
            <div v-if="currentTypeFields.indexOf('saudiBuildingCode') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مطابق لكود البناء السعودي؟:</label>
              <select v-model="saudiBuildingCode" class="form-control">
                <option :value="true">نعم</option>
                <option :value="false">لا</option>
              </select>
            </div>
            <div v-if="currentTypeFields.indexOf('plotNumber') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم القطعة:</label>
              <input type="text" v-model="plotNumber" class="form-control">
            </div>
            <div v-if="currentTypeFields.indexOf('meterPrice') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">سعر المتر:</label>
              <input type="text" v-model="meterPrice" class="form-control">
            </div>
            <div v-if="currentTypeFields.indexOf('halls') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الصالات:</label>
              <input type="number" v-model="halls" class="form-control">
            </div>
            <div v-if="currentTypeFields.indexOf('age') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عمر العقار:</label>
              <select v-model="age" class="form-control">
                <option :value="null">اختر العمر</option>
                <option v-for="f in agesList" :value="f.id" :key="f.id">{{ f.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">هل يوجد أي التزام على العقار؟:</label>
              <select v-model="hasObligations" class="form-control">
                <option :value="true">نعم</option>
                <option :value="false">لا</option>
              </select>
            </div>
          </div>

          <div class="row" v-for="(feature, index) in featuresList" :key="index">
            <div class="col mb-4">
              <label for="" class="form-label"><i class="bi bi-record"></i> {{ feature.category }}:</label>
              <div class="row">
                <div class="col-6 col-sm-4 mb-3" v-for="featureData in feature.features" :key="featureData.id">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="featureData.id" :id="`features_${featureData.id}`" name="features[]" v-model="features">
                    <label class="form-check-label" :for="`features_${featureData.id}`">
                      <img v-if="featureData.icon" :src="MEDIA_URL+featureData.icon" class="rounded" style="max-width: 28px;" alt="">
                      {{ featureData.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Property Additionals -->
        <div v-if="step == 4">
          <div v-if="!dataRow || !dataRow.id" class="alert alert-info">
            يجب حفظ العقار أولاً قبل إضافة البيانات الإضافية
          </div>

          <PropertyAdditionals
            v-else
            :propertyId="dataRow.id"
          />
        </div>
        <!-- images -->
        <div v-if="step == 5">
          <div class="row pb-3">
            <div class="col text-end">
              <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#uploadModal"><i class="bi bi-file-earmark-arrow-up"></i> إضافة صورة</button>
              <!-- Modal -->
              <div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="uploadModalLabel">إضافة صورة</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="row justify-content-center">
                        <div class="col-12 col-sm-8">
                          <input type="file" v-if="!mediaLoader" class="form-control" @change="uploadMedia($event.target.files)" multiple accept=".png,.jpg,.jpeg,.pmb,.webp">
                          <loader v-if="mediaLoader" />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">اغلاق</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-3 media-img-container mb-3" v-for="(img, indx) in mediaList" :key="indx">
              <img :src="MEDIA_URL+img.path" class="img-thumbnail img-fluid" alt="">
              <button type="button" class="btn btn-danger btn-sm" @click="deleteMedia(img.id)"><i class="bi bi-trash"></i></button>
            </div>
          </div>
        </div>
        <!-- property details -->
        <div v-if="step == 6">
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مندوب العقارية:</label>
              <select class="form-control" v-model="agentId">
                <option :value="null">لم يعين له مندوب</option>
                <option :value="agent.id" v-for="agent in agentsList" :key="agent.id">{{ agent.name }}</option>
              </select>
            </div>
            <!-- <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مدة الإعلان:</label>
              <select class="form-control" v-model="adDuration">
                <option :value="period.val" v-for="(period, i) in durations" :key="i">{{ period.label }}</option>
              </select>
            </div> -->
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" :value="true" id="isFeatured1" v-model="isFeatured">
                <label class="form-check-label" for="isFeatured1">
                  الإعلان يصنف كإعلان مميز
                </label>
              </div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">قيمة الإعلان المميز:</label>
              <div>{{ featuredAmount }} {{ (isPayed)? 'مدفوعه' : 'غير مدفوعه' }}</div>
              <div class="form-text">في حالة كان الإعلان يصنف كإعلان مميز</div>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
              <label class="form-label">تابع لعقار متعدد الوحدات:</label>
              <select class="form-control" v-model="containerId" @change="setContainerProject">
                <option :value="null">غير تابع لوحدة</option>
                <option v-for="c in containers" :key="c.id" :value="c.id">{{ c.title }}</option>
              </select>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">حالة الإعلان:</label>
              <select class="form-control" v-model="status">
                <option v-for="(val, key) in statusChoices" :key="key" :value="key">{{ val }}</option>
              </select>
              <div v-if="dataRow && dataRow.statusReason">{{ dataRow.statusReason }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">سبب رفض الإعلان:</label>
              <textarea class="form-control" v-model="rejectionNote" cols="5"></textarea>
              <div class="form-text">توضيح سبب رفض الإعلان في حالة كانت حالة الإعلان مرفوض</div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" :value="true" id="manageProperty" v-model="manageProperty">
                <label class="form-check-label" for="manageProperty">
                  هل يتم إدارة هذا العقار من قبل شركة احمد المحيسني العقارية ؟
                </label>
              </div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="managementType" class="form-label">نوع الإدارة / التسويق</label>
              <select id="managementType" v-model="managementType" class="form-control">
                <option v-for="(label, value) in managementTypeChoices" :key="value" :value="value === 'null' ? null : value">{{ label }}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- property managment -->
        <div v-if="step == 7">
          <div class="row" v-if="!manageProperty">
            <div class="col">
              <div class="alert alert-info">هذا العقار لا يتم إدارته من قبل شركة احمد المحيسني العقارية</div>
            </div>
          </div>
          <div v-if="manageProperty">
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label class="form-label" for="">{{ (purpose == 'for_rent')? 'المستأجر' : 'المالك' }} الحالي:</label>
                <input type="text" class="form-control" placeholder="جوال العميل" @keyup="getRentalData()" v-model="rentalMobile">
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <loader v-if="rentalLoader" />
                <div v-if="rentalName">
                  <label class="form-label" for="">اسم العميل:</label>
                  <div>{{ rentalName }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">إجمالي سعر {{ (purpose == 'for_rent')? 'الإيجار' : 'البيع' }}:</label>
                <input type="number" class="form-control" v-model="finalPrice">
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="commissionType" class="form-label">نوع العمولة العقارية:</label>
                <select id="commissionType" class="form-select mb-2" v-model="commissionType">
                  <option v-for="(label, value) in commissionTypeChoices" :key="value" :value="value">{{ label }}</option>
                </select>
                <label for="commission" class="form-label">{{ commissionType === 'fixed' ? 'مبلغ العمولة (ريال):' : 'نسبة العمولة (%):' }}</label>
                <input id="commission" type="number" class="form-control mb-1" v-model="commission" min="0" :max="commissionType === 'percent' ? 100 : undefined" :step="commissionType === 'percent' ? '0.0001' : '0.01'">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="true" id="commissionCollected1" v-model="commissionCollected">
                  <label class="form-check-label" for="commissionCollected1">
                    تم تحصيل عمولة العقارية
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">تاريخ استلام العقار:</label>
                <input type="date" class="form-control" v-model="startDate">
              </div>
            </div>
            <div v-if="purpose == 'for_rent'" class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">مدة الإيجار:</label>
                <div class="input-group">
                  <input type="number" v-model="rentalTerm" class="form-control" placeholder="مدة الإيجار" aria-label="" aria-describedby="rentalTerm">
                  <select v-model="rentalUnit" id="rentalTerm" class="form-control">
                    <option value="day">يوم</option>
                    <option value="month">شهر</option>
                    <option value="year">سنوات</option>
                  </select>
                </div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">تاريخ نهاية الإيجار:</label>
                <input type="date" class="form-control" v-model="rentExpire">
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">اجمالي المبلغ المحصل:</label>
                <div>{{ collectedAmount }}</div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">اجمالي المبلغ المتبقي:</label>
                <div>{{ remainingPayments }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="true" id="hasLawsuit1" v-model="hasLawsuit">
                  <label class="form-check-label" for="hasLawsuit1">
                    يوجد رفع قضية على هذا العقار
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col"><hr></div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-head">الدفعات المالية:</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <div v-for="(pay , index) in propertyPayments" :key="index" class="row border-bottom pb-3 mb-3">
                  <div class="col-6 col-sm-3">
                    <label for="" class="form-label">المبلغ</label>
                    <input type="number" class="form-control" v-model="pay.amount">
                  </div>
                  <div class="col-6 col-sm-2">
                    <label for="" class="form-label">تاريخ الإستحقاق</label>
                    <input type="date" class="form-control" v-model="pay.dueDate">
                  </div>
                  <div class="col-6 col-sm-2">
                    <label for="" class="form-label">تم السداد</label>
                    <select class="form-control" v-model="pay.isPaid">
                      <option :value="true">نعم</option>
                      <option :value="false">لا</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-2">
                    <label for="" class="form-label">تاريخ السداد</label>
                    <input type="date" class="form-control" v-model="pay.paymentDate">
                  </div>
                  <div class="col-6 col-sm-2 pt-4">
                    <button type="button" class="btn btn-danger btn-sm" @click="removePayment(index)"><i class="bi bi-trash"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-12 text-end">
                <button type="button" class="btn btn-light" @click="addPayment()">إضافة دفعة</button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 8">
          <PropertyAttachments v-if="dataRow" :propertyId="dataRow.id" />
          <div v-else class="alert alert-info">يجب حفظ العقار أولاً قبل إضافة المرفقات</div>
        </div>
        <div v-if="step == 9">
          <div v-if="dataRow" class="row">
            <div class="col mb-5" id="validatorForm">
              <fieldset>
                <legend>التحقق من رقم ترخيص الإعلان:</legend>
                <div class="row">
                  <div class="col-6 col-sm-3">
                    <label class="form-label">رقم ترخيص الإعلان:</label>
                    <input type="text" class="form-control" v-model="validatorAdLicenseNumber">
                  </div>
                  <div class="col-6 col-sm-3">
                    <label class="form-label">نوع هوية المُعلن:</label>
                    <select class="form-control" v-model="validatorIdType">
                      <option value="1">رقم الهوية</option>
                      <option value="2">الرقم الموحد للمنشأة</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3">
                    <label class="form-label">رقم هوية المُعلن:</label>
                    <input type="text" class="form-control" v-model="validatorAdvertiserId">
                  </div>
                  <div class="col-6 col-sm-3 set-padding">
                    <button v-if="!regaValidateLoader" type="button" class="btn btn-warning btn-sm" @click.prevent="checkAdLicense"><i class="fa-solid fa-clipboard-check"></i> التحقق</button>
                    <loader v-if="regaValidateLoader" />
                  </div>
                </div>
              </fieldset>
            </div>
            <div v-if="checkAccess('property_rega_update')" class="row">
              <div class="col text-end">
                <router-link :to="`/regaUpdate/create/${dataRow.id}`" class="btn btn-warning">ارسال تحديث إلى الهيئة</router-link>
              </div>
            </div>
          </div>
          <div v-if="!regaAdValidator" class="row mt-3">
            <div class="col">
              <div class="alert alert-warning">لم يتم التحقق من رقم ترخيص الإعلان لدى الهيئة العامة للعقار الآن ،،،</div>
            </div>
          </div>
          <div v-if="regaAdValidator" class="row">
            <div class="col">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <strong>يوجد ترخيص: </strong>{{ (regaAdValidator.isValid)? 'نعم' : 'لا' }}
                </div>
                <div v-if="regaAdValidator.message" class="col-12 col-sm-6">
                  <strong>رسالة الخطأ: </strong>{{ regaAdValidator.message }}
                </div>
              </div>
              <div v-if="regaAdValidator.advertisement" class="table-responsive">
                <table class="table table-striped">
                  <tbody>
                    <tr>
                      <th>رقم هوية المعلن:</th>
                      <td>{{ regaAdValidator.advertisement.advertiserId }}</td>
                      <th>رقم ترخيص الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.adLicenseNumber }}</td>
                    </tr>
                    <tr>
                      <th>رقم وثيقة الملكية / ملكية المنفعة:</th>
                      <td>{{ regaAdValidator.advertisement.deedNumber }}</td>
                      <th>اسم المعلن:</th>
                      <td>{{ regaAdValidator.advertisement.advertiserName }}</td>
                    </tr>
                    <tr>
                      <th>مسؤول الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.responsibleEmployeeName }}</td>
                      <th>رقم جوال مسؤول الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.responsibleEmployeePhoneNumber }}</td>
                    </tr>
                    <tr>
                      <th>رقم التواصل للمعلن:</th>
                      <td>{{ regaAdValidator.advertisement.phoneNumber }}</td>
                      <th>رقم رخصة الوساطة والتسويق العقاري:</th>
                      <td>{{ regaAdValidator.advertisement.brokerageAndMarketingLicenseNumber }}</td>
                    </tr>
                    <tr>
                      <th>وجود قيود؟:</th>
                      <td>{{ (regaAdValidator.advertisement.isConstrained)? 'نعم' : 'لا' }}</td>
                      <th>وجود رهن؟:</th>
                      <td>{{ (regaAdValidator.advertisement.isPawned)? 'نعم' : 'لا' }}</td>
                    </tr>
                    <tr>
                      <th>وجود وقف؟:</th>
                      <td>{{ (regaAdValidator.advertisement.isHalted)? 'نعم' : 'لا' }}</td>
                      <th>وجود وصية؟:</th>
                      <td>{{ (regaAdValidator.advertisement.isTestment)? 'نعم' : 'لا' }}</td>
                    </tr>
                    <tr>
                      <th>قيود السجل العيني:</th>
                      <td><pre>{{ regaAdValidator.advertisement.rerConstraints }}</pre></td>
                      <th>عرض الشارع:</th>
                      <td>{{ regaAdValidator.advertisement.streetWidth }}</td>
                    </tr>
                    <tr>
                      <th>مساحة العقار:</th>
                      <td>{{ regaAdValidator.advertisement.propertyArea }}</td>
                      <th>سعر الوحدة / سعر المتر للارض:</th>
                      <td>{{ regaAdValidator.advertisement.propertyPrice }}</td>
                    </tr>
                    <tr>
                      <th>اجمالي سعر بيع الارض:</th>
                      <td>{{ regaAdValidator.advertisement.landTotalPrice }}</td>
                      <th>اجمالي الإيجار السنوي للارض:</th>
                      <td>{{ regaAdValidator.advertisement.landTotalAnnualRent }}</td>
                    </tr>
                    <tr>
                      <th>عدد الغرف:</th>
                      <td>{{ regaAdValidator.advertisement.numberOfRooms }}</td>
                      <th>نوع العقار:</th>
                      <td>{{ regaAdValidator.advertisement.propertyType }}</td>
                    </tr>
                    <tr>
                      <th>عمر العقار:</th>
                      <td>{{ regaAdValidator.advertisement.propertyAge }}</td>
                      <th>غرض الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.advertisementType }}</td>
                    </tr>
                    <tr>
                      <th>العنوان:</th>
                      <td><pre>{{ regaAdValidator.advertisement.location }}</pre></td>
                      <th>واجهة العقار:</th>
                      <td>{{ regaAdValidator.advertisement.propertyFace }}</td>
                    </tr>
                    <tr>
                      <th>رقم المخطط:</th>
                      <td>{{ regaAdValidator.advertisement.planNumber }}</td>
                      <th>رقم القطعة:</th>
                      <td>{{ regaAdValidator.advertisement.landNumber }}</td>
                    </tr>
                    <tr>
                      <th>الإلتزامات على العقار:</th>
                      <td>{{ regaAdValidator.advertisement.obligationsOnTheProperty }}</td>
                      <th>الضمانات ومدتها:</th>
                      <td>{{ regaAdValidator.advertisement.guaranteesAndTheirDuration }}</td>
                    </tr>
                    <tr>
                      <th>مطابقة كود البناء السعودي:</th>
                      <td>{{ regaAdValidator.advertisement.complianceWithTheSaudiBuildingCode }}</td>
                      <th>قنوات الإعلان:</th>
                      <td><pre>{{ regaAdValidator.advertisement.channels }}</pre></td>
                    </tr>
                    <tr>
                      <th>استخدام العقار:</th>
                      <td><pre>{{ regaAdValidator.advertisement.propertyUsages }}</pre></td>
                      <th>نوع استخدام الارض:</th>
                      <td>{{ regaAdValidator.advertisement.mainLandUseTypeName }}</td>
                    </tr>
                    <tr>
                      <th>نوع منع التصرف:</th>
                      <td>{{ regaAdValidator.advertisement.redZoneTypeName }}</td>
                      <th>خدمات العقار:</th>
                      <td><pre>{{ regaAdValidator.advertisement.propertyUtilities }}</pre></td>
                    </tr>
                    <tr>
                      <th>تاريخ إنشاء ترخيص الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.creationDate }}</td>
                      <th>تاريخ إنتهاء ترخيص الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.endDate }}</td>
                    </tr>
                    <tr>
                      <th>رابط ترخيص الإعلان:</th>
                      <td><a :href="regaAdValidator.advertisement.adLicenseUrl" target="_blank">فتح الرابط</a></td>
                      <th>مصدر ترخيص الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.adSource }}</td>
                    </tr>
                    <tr>
                      <th>نوع وثيقة الملكية / نوع وثيقة المنفعة:</th>
                      <td>{{ regaAdValidator.advertisement.titleDeedTypeName }}</td>
                      <th>وصف موقع العقار حسب الصك:</th>
                      <td>{{ regaAdValidator.advertisement.locationDescriptionOnMOJDeed }}</td>
                    </tr>
                    <tr>
                      <th>الملاحظات:</th>
                      <td>{{ regaAdValidator.advertisement.notes }}</td>
                      <th>حدود واطوال العقار من وزارة العدل:</th>
                      <td><pre>{{ regaAdValidator.advertisement.borders }}</pre></td>
                    </tr>
                    <tr>
                      <th>حدود واطوال العقار من السجل العقاري:</th>
                      <td><pre>{{ regaAdValidator.advertisement.rerBorders }}</pre></td>
                      <th>رسوم نقل الملكية:</th>
                      <td><pre>{{ regaAdValidator.advertisement.ownershipTransferFeeType }}</pre></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 10 && checkAccess('property_banner_requests_read')">
          <PropertyMarketingMaterials v-if="dataRow" :propertyId="dataRow.id" />
          <div v-else class="alert alert-info">يجب حفظ العقار أولاً قبل إنشاء طلبات المواد التسويقية واللوحات</div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-start">
            <button v-if="step > 1" type="button" class="btn btn-secondary" @click="prevStep"><i class="bi bi-arrow-bar-right"></i> السابق</button>
          </div>
          <div class="col text-end">
            <button v-if="step == 7 && !formLoader" type="submit" class="btn btn-success me-3">ارسل</button>
            <loader v-if="step == 7 && formLoader" />
            <button v-if="step < stepTitles.length" type="button" class="btn btn-secondary" @click="nextStep">التالي <i class="bi bi-arrow-bar-left"></i></button>
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, shortDate, checkAccess } from '@/helpers/tools';
import PropertyAttachments from '@/components/PropertyAttachments.vue';
import PropertyAdditionals from '@/components/PropertyAdditionals.vue'
import PropertyMarketingMaterials from '@/components/PropertyMarketingMaterials.vue';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'PropertiesForm',
  components: { PropertyAttachments, PropertyAdditionals, PropertyMarketingMaterials },
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    copyFromData: {
      type: Object,
      default: null,
    },
    currentUserContainers: {
      type: Array,
      default: [],
    },
  },
  data(){
    return {
      mainLoading: true,
      userLoader: false,
      mediaLoader: false,
      formLoader: false,
      rentalLoader: false,
      regaValidateLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      step: 1,
      stepTitles: [
        "نوع المالك",
        "بيانات المالك",
        "بيانات العقار",
        "بيانات إضافية",
        "الصور",
        "تفاصيل الإعلان",
        "إدارة العقار",
        "مرفقات العقار",
        "هيئة العقار",
        ...(this.dataRow && checkAccess('property_banner_requests_read') ? ["المواد التسويقية واللوحات"] : []),
      ],
      // for config
      regionsList: [],
      typesList: [],
      typesListOriginal: [],
      featuresList: [],
      durations: [],
      agentsList: [],
      userMobile: null,
      userName: null,
      uploadedReceipt: null,
      uploadedAgencyImage: null,
      citiesList: [],
      neighborhoodsList: [],
      mediaList: [],
      createdBy: null,
      statusChoices: {},
      rentalMobile: null,
      rentalName: null,
      uploadedIdentityImage: null,
      uploadedBuildingPermitImage: null,
      uploadedDefenseCertificateImage: null,
      frontsList: [],
      agesList: [],
      // for form owner
      userId: null,
      projectId: null,
      projectsList: [],
      ownerType: "owner",
      receiptImage: null,
      agencyImage: null,
      receiptNumber: null,
      // receiptDate: null,
      ownerIdentity: null,
      ownerDOB: null,
      ownerMobile: null,
      agentIdentity: null,
      agencyNumber: null,
      agencyDate: null,
      // agentDOB: null,
      agentMobile: null,
      falLicense: null,
      adLicenseNumber: null,
      identityImage: null,
      buildingPermitImage: null,
      defenseCertificateImage: null,
      // for property form
      category: 'residential',
      purpose: 'for_sale',
      regionId: null,
      cityId: null,
      neighborhoodId: null,
      street: '',
      buildNumber: '',
      floorsCount: 0,
      floorNumber: 0,
      apartmentNumber: 0,
      typeId: null,
      title: '',
      description: '',
      price: 0,
      latitude: 24.7136,
      longitude: 46.6753,
      propertyType: null,
      area: 0,
      roomsCount: 0,
      bathrooms: 0,
      age: null,
      agentId: null,
      status: 'available',
      manageProperty: true,
      adDuration: '1',
      isFeatured: false,
      rejectionNote: '',
      startDate: null,
      rentExpire: null,
      mediaIds: [],
      features: [],
      map: null,
      marker: null,
      frontId: null,
      furnished: false,
      hasObligations: false,
      saudiBuildingCode: false,
      plotNumber: null,
      meterPrice: null,
      halls: null,
      // for property managment
      tenant: null,
      finalPrice: 0,
      collectedAmount: 0,
      remainingPayments: 0,
      rentalTerm: 0,
      rentalUnit: 'year',
      featuredAmount: 0,
      commission: 0,
      commissionCollected: false,
      isPayed: false,
      propertyPayments: [],
      currentTypeFields: [],
      containerId: null,
      containers: [],
      regaAdValidator: null,
      validatorAdLicenseNumber: null,
      validatorIdType: null,
      validatorAdvertiserId: null,
      couponCode: '',
      couponLoading: false,
      couponResult: null,
      searchCity: null,
      searchNeighborhood: null,
      hasLawsuit: false,
      managementType: null,
      managementTypeChoices: {},
      crmChat: false,
      commissionType: 'percent',
      commissionTypeChoices: { percent: 'نسبة مئوية', fixed: 'مبلغ ثابت' },
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API']),
    isArchived(){
      return Boolean(this.dataRow && (this.dataRow.archivedAt || this.dataRow.isArchived || this.dataRow.archived));
    },
  },
  watch: {
    mainLoading(loading){
      if(loading) this.destroyFormSelect2();
      else this.applyFormSelect2();
    },
    step(){
      this.destroyFormSelect2();
      this.applyFormSelect2();
    },
    projectsList(){ this.applySelect2Projects(); },
    projectId(){ this.applySelect2Projects(); },
    containerId(){ this.applySelect2Projects(); },
    citiesList(){ this.applySelect2Cities(); },
    cityId(){ this.applySelect2Cities(); },
    neighborhoodsList(){ this.applySelect2Neighborhoods(); },
    neighborhoodId(){ this.applySelect2Neighborhoods(); },
    typesList(){ this.applySelect2Types(); },
    typeId(){ this.applySelect2Types(); },
    frontsList(){ this.applySelect2Fronts(); },
    frontId(){ this.applySelect2Fronts(); },
  },
  mounted(){
    this.applyFormSelect2();
  },
  beforeUnmount(){
    this._select2Disposed = true;
    this.destroyFormSelect2();
  },
  methods: {
    checkAccess,
    setProject(containerId = null){
      const project = this.projectsList.find(row => row.id == this.projectId);
      this.containerId = null;
      this.containers = [];
      if(!project){
        if(this.userMobile) this.getClientData();
        return;
      }
      this.userId = project.userId;
      this.userMobile = project.User?.mobile || null;
      this.userName = project.User?.name || null;
      this.regionId = project.regionId;
      this.cityId = project.cityId;
      this.neighborhoodId = project.neighborhoodId;
      this.getCitiesList(false);
      this.getNeighborhoodsList(false);
      if(this.userMobile) this.getClientData(containerId);
    },
    setContainerProject(){
      const container = this.containers.find(row => row.id == this.containerId);
      if(!container) return;
      this.projectId = container.projectId || null;
      const project = this.projectsList.find(row => row.id == this.projectId);
      this.regionId = container.regionId || project?.regionId || this.regionId;
      this.cityId = container.cityId || project?.cityId || this.cityId;
      this.neighborhoodId = container.neighborhoodId || project?.neighborhoodId || this.neighborhoodId;
      this.getCitiesList(false);
      this.getNeighborhoodsList(false);
    },
    archiveProperty(){
      this.$swal.fire({
        title: 'هل تريد أرشفة هذا العقار؟',
        text: 'يمكن استرجاعه لاحقاً من صفحة الأرشيف.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'أرشفة',
        cancelButtonText: 'إلغاء',
        confirmButtonColor: '#6c757d',
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.$http.put(`/api/admin/properties/archive/${this.dataRow.id}`).then(() => {
          toast('تم أرشفة العقار بنجاح', 'success');
          this.$router.push('/properties/archive');
        }).catch(() => toast('تعذر أرشفة العقار'));
      });
    },
    restoreProperty(){
      this.$swal.fire({
        title: 'هل تريد استرجاع هذا العقار؟',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'استرجاع',
        cancelButtonText: 'إلغاء',
        confirmButtonColor: '#198754',
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.$http.put(`/api/admin/properties/restore/${this.dataRow.id}`).then(() => {
          toast('تم استرجاع العقار بنجاح', 'success');
          this.$router.push(`/properties/update/${this.dataRow.id}`);
        }).catch(() => toast('تعذر استرجاع العقار'));
      });
    },
    prevStep(){
      this.step = this.step - 1;
      if(this.step == 3){
        this.initialGoogleMap();
        this.applySelect2Cities();
        this.applySelect2Neighborhoods();
        this.applySelect2Types();     
        this.applySelect2Fronts();
      }
    },
    nextStep(){
      this.hasError = false;
      this.errorNumber = 0;
      if(this.step == 1){
        if(!this.userId){
          this.message = 'يجب اختيار العميل';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
      }
      if(this.step == 2){
        if(this.ownerType == 'owner'){
          if(!this.ownerIdentity || this.ownerIdentity == ''){
            this.message = 'يجب ادخال رقم هوية المالك';
            this.hasError = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
          if(!this.ownerDOB || this.ownerDOB.trim() == ''){
            this.message = 'يجب ادخال تاريخ ميلاد المالك';
            this.hasError = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
          if(!this.ownerMobile || this.ownerMobile.trim() == ''){
            this.message = 'يجب ادخال رقم جوال المالك';
            this.hasError = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
        }
        if(this.ownerType == 'agent'){
          // if(!this.ownerIdentity || this.ownerIdentity == ''){
          //   this.message = 'يجب ادخال رقم هوية المالك';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
          // if(!this.ownerDOB || this.ownerDOB.trim() == ''){
          //   this.message = 'يجب ادخال تاريخ ميلاد المالك';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
          if(!this.agentIdentity || this.agentIdentity == ''){
            this.message = 'يجب ادخال رقم هوية الوكيل';
            this.hasError = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
          // if(!this.agentDOB || this.agentDOB.trim() == ''){
          //   this.message = 'يجب ادخال تاريخ ميلاد الوكيل';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
          if(!this.agencyNumber || this.agencyNumber.trim() == ''){
            this.message = 'يجب ادخال رقم الوكالة الوكيل';
            this.hasError = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
          if(!this.agentMobile || this.agentMobile.trim() == ''){
            this.message = 'يجب ادخال رقم جوال الوكيل';
            this.hasError = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
        }
        if(this.ownerType == 'broker'){
          if(!this.falLicense || this.falLicense.trim() == ''){
            this.message = 'يجب ادخال رقم رخصة فال';
            this.hasError = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
          if(!this.adLicenseNumber || this.adLicenseNumber.trim() == ''){
            this.message = 'يجب ادخال رقم ترخيص الإعلان';
            this.hasError = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
          // if(!this.ownerDOB || this.ownerDOB.trim() == ''){
          //   this.message = 'يجب ادخال تاريخ ميلاد المالك';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
          // if(!this.ownerMobile || this.ownerMobile.trim() == ''){
          //   this.message = 'يجب ادخال رقم جوال المالك';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
          // if(!this.agentIdentity || this.agentIdentity == ''){
          //   this.message = 'يجب ادخال رقم هوية الوكيل';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
          // if(!this.agentDOB || this.agentDOB.trim() == ''){
          //   this.message = 'يجب ادخال تاريخ ميلاد الوكيل';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
          // if(!this.agencyNumber || this.agencyNumber.trim() == ''){
          //   this.message = 'يجب ادخال رقم الوكالة';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
          // if(!this.agentMobile || this.agentMobile.trim() == ''){
          //   this.message = 'يجب ادخال رقم جوال الوكيل';
          //   this.hasError = true;
          //   window.scrollTo({ top: 0, behavior: 'smooth' });
          //   return false;
          // }
        }
      }
      if(this.step == 3){
        if(!this.category){
          this.message = 'يجب اختيار تصنيف العقار';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.purpose){
          this.message = 'يجب اختيار الغرض من الاعلان';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.typeId){
          this.message = 'يجب اختيار نوع العقار';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        // if(!this.propertyType){
        //   this.message = 'يجب اختيار نوع الساكن';
        //   this.hasError = true;
        //   window.scrollTo({ top: 0, behavior: 'smooth' });
        //   return false;
        // }
        if(!this.title || this.title.trim() == ''){
          this.message = 'يجب ادخال الوصف المتخصر';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.description || this.description.trim() == ''){
          this.message = 'يجب ادخال الوصف';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.regionId){
          this.message = 'يجب اختيار المنطقة';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.cityId){
          this.message = 'يجب اختيار المدينة';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        // if(!this.neighborhoodId){
        //   this.message = 'يجب اختيار الحي';
        //   this.hasError = true;
        //   window.scrollTo({ top: 0, behavior: 'smooth' });
        //   return false;
        // }
      }
      this.step = this.step + 1;
      if(this.step == 3){
        this.initialGoogleMap();
        this.applySelect2Cities();
        this.applySelect2Neighborhoods();
        this.applySelect2Types();     
        this.applySelect2Fronts();
      }
    },
    getInitData(){
      this.$http.get('/api/admin/properties/init').then(({data}) => {
        this.regionsList = data.regionsList;
        this.projectsList = data.projectsList || [];
        if(!this.dataRow && !this.copyFromData && this.$route.query.projectId){
          const project = this.projectsList.find(row => row.id == this.$route.query.projectId);
          if(project){
            this.projectId = project.id;
            this.setProject(this.$route.query.containerId || null);
          }
        }
        this.typesListOriginal = data.typesList;
        this.featuresList = data.featuresList;
        this.durations = data.durations;
        this.agentsList = data.agentsList;
        this.statusChoices = data.statusChoices;
        this.frontsList = data.frontsList;
        this.agesList = data.agesList;
        this.managementTypeChoices = data.propertyManagementTypeChoices || {};
        this.commissionTypeChoices = data.propertyCommissionTypeChoices || this.commissionTypeChoices;
        this.setTypesList();
        this.mainLoading = false;
        this.$nextTick(() => {
          this.applySelect2Fronts();
        });
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getClientData(containerId = null){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.userLoader = true;
        const requestMobile = this.userMobile.trim();
        const requestProjectId = this.projectId;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: requestMobile,
        }).then(({data}) => {
          if(this.userMobile?.trim() !== requestMobile || this.projectId != requestProjectId) return;
          this.userId = data.user.id;
          this.userName = data.user.name;
          this.containers = data.containers ?? [];
          if(containerId && this.containers.some(row => row.id == containerId)){
            this.containerId = Number(containerId);
            this.setContainerProject();
          }else if(this.containerId && !this.containers.some(row => row.id == this.containerId)){
            this.containerId = null;
          }
          this.userLoader = false;
        }).catch(err => {
          if(this.userMobile?.trim() !== requestMobile || this.projectId != requestProjectId) return;
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          // window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    getRentalData(){
      this.tenant = null;
      this.rentalName = null;
      if(this.rentalMobile && this.rentalMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.rentalLoader = true;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: this.rentalMobile.trim(),
        }).then(({data}) => {
          this.tenant = data.user.id;
          this.rentalName = data.user.name;
          this.rentalLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.rentalLoader = false;
          // window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    setReceiptImage(files){
      this.receiptImage = [...files];
    },
    setAgencyImage(files){
      this.agencyImage = [...files];
    },
    getCitiesList(change=true){
      this.hasError = false;
      this.citiesList = [];
      this.neighborhoodsList = [];
      if(change){
        this.cityId = null;
        this.neighborhoodId = null;
      }
      if(!this.regionId){
        return;
      }
      const requestRegionId = this.regionId;
      this.$http.get(`/api/admin/cities/list?regionId=${this.regionId}&all=1`).then(({data}) => {
        if(this._select2Disposed || this.regionId != requestRegionId) return;
        this.citiesList = data.cities;
        this.$nextTick(() => {
          this.applySelect2Cities();
        });
      }).catch(err => {
        if(this._select2Disposed || this.regionId != requestRegionId) return;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getNeighborhoodsList(change=true){
      this.hasError = false;
      this.neighborhoodsList = [];
      if(change)
        this.neighborhoodId = null;
      if(!this.cityId){
        return;
      }
      const requestCityId = this.cityId;
      this.$http.get(`/api/admin/neighborhoods/list?cityId=${this.cityId}&all=1`).then(({data}) => {
        if(this._select2Disposed || this.cityId != requestCityId) return;
        this.neighborhoodsList = data.neighborhoods;
        this.$nextTick(() => {
          this.applySelect2Neighborhoods();
        });
      }).catch(err => {
        if(this._select2Disposed || this.cityId != requestCityId) return;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async uploadMedia(files){
      this.mediaLoader = true;
      for(let i=0; i<files.length; i++){
        const formData = new FormData();
        formData.append('file', files[i]);
        try {
          const mFile = await this.$http.post('/api/admin/media/upload', formData);
          if(mFile){
            this.mediaIds.push(mFile.data.mediaId);
            this.mediaList.push({
              id: mFile.data.mediaId,
              path: mFile.data.filePath,
            });
          }
        }catch(err){
          // console.log(err);
        }
      }
      this.mediaLoader = false;
      toast('تم رفع الصور بنجاح', 'success');
    },
    deleteMedia(id){
      this.$swal.fire({
        title: "هل تريد تأكيد حذف الصورة؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/media/delete/${id}`).then(({data}) => {
            this.mediaIds.splice(this.mediaIds.indexOf(id), 1);
            let mediaArray = [];
            this.mediaList.map(m => {
              if(m.id != id)
                mediaArray.push(m);
            });
            this.mediaList = mediaArray;
            toast('تم حذف الصورة بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف الصورة');
          });
        }
      });
    },
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      if(!this.userId){
        this.message = `يجب اختيار العميل`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }

      if(this.ownerType == 'owner'){
        if(!this.ownerIdentity || this.ownerIdentity == ''){
          this.message = `يجب ادخال رقم هوية المالك`;
          this.hasError = true;
          this.formLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.ownerDOB || this.ownerDOB.trim() == ''){
          this.message = `يجب ادخال تاريخ ميلاد المالك`;
          this.hasError = true;
          this.formLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.ownerMobile || this.ownerMobile.trim() == ''){
          this.message = `يجب ادخال رقم جوال المالك`;
          this.hasError = true;
          this.formLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
      }

      if(this.ownerType == 'agent'){
        if(!this.agentIdentity || this.agentIdentity == ''){
          this.message = `يجب ادخال رقم هوية الوكيل`;
          this.hasError = true;
          this.formLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.agencyNumber || this.agencyNumber.trim() == ''){
          this.message = `يجب ادخال رقم الوكالة الوكيل`;
          this.hasError = true;
          this.formLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.agentMobile || this.agentMobile.trim() == ''){
          this.message = `يجب ادخال رقم جوال الوكيل`;
          this.hasError = true;
          this.formLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
      }

      if(this.ownerType == 'broker'){
        if(!this.falLicense || this.falLicense.trim() == ''){
          this.message = `يجب ادخال رقم رخصة فال`;
          this.hasError = true;
          this.formLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.adLicenseNumber || this.adLicenseNumber.trim() == ''){
          this.message = `يجب ادخال رقم ترخيص الإعلان`;
          this.hasError = true;
          this.formLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        // if(!this.agentMobile || this.agentMobile.trim() == ''){
        //   this.message = `يجب ادخال رقم جوال الوكيل`;
        //   this.hasError = true;
        //   this.formLoader = false;
        //   window.scrollTo({ top: 0, behavior: 'smooth' });
        //   return false;
        // }
      }

      if(!this.category){
        this.message = `يجب اختيار تصنيف العقار`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(!this.purpose){
        this.message = `يجب اختيار الغرض من الاعلان`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(!this.typeId){
        this.message = `يجب اختيار نوع العقار`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(!this.title || this.title.trim() == ''){
        this.message = `يجب ادخال الوصف المتخصر`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(!this.description || this.description.trim() == ''){
        this.message = `يجب ادخال الوصف`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(!this.regionId){
        this.message = `يجب اختيار المنطقة`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(!this.cityId){
        this.message = `يجب اختيار المدينة`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      // if(!this.neighborhoodId){
      //   this.message = `يجب اختيار الحي`;
      //   this.hasError = true;
      //   this.formLoader = false;
      //   window.scrollTo({ top: 0, behavior: 'smooth' });
      //   return false;
      // }

      if(this.tenant && ['sold', 'rented', 'reserved'].indexOf(this.status) == -1){
        this.message = `لا يمكن إضافة مالك أو مستأجر وحالة العقار ${this.statusChoices[this.status]}`;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if((!this.rejectionNote || this.rejectionNote.trim() == '') && this.status == 'rejected'){
        this.message = 'يجب إدخال سبب رفض الإعلان';
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(!this.tenant && this.propertyPayments.length){
        this.message = 'لا يمكن إضافة دفعات مالية بدون مالك او مستأجر';
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(this.propertyPayments.length && this.status == 'sold'){
        this.message = 'لا يمكن إضافة دفعات مالية إلى عقار مُباع';
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(this.tenant && !this.finalPrice){
        this.message = 'يجب إدخال إجمالي السعر';
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      if(this.tenant && !this.startDate){
        this.message = 'يجب إدخال تاريخ الإستلام';
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }

      let owner = {
        userId: this.userId,
        ownerType: this.ownerType,
        receiptNumber: this.receiptNumber,
        // receiptDate: this.receiptDate,
        ownerIdentity: this.ownerIdentity,
        ownerDOB: this.ownerDOB,
        ownerMobile: this.ownerMobile,
        agentIdentity: this.agentIdentity,
        agencyNumber: this.agencyNumber,
        agencyDate: this.agencyDate,
        // agentDOB: this.agentDOB,
        agentMobile: this.agentMobile,
        falLicense: this.falLicense,
        adLicenseNumber: this.adLicenseNumber,
        crmChat: this.crmChat,
      };
      let property = {
        category: this.category,
        purpose: this.purpose,
        regionId: this.regionId,
        cityId: this.cityId,
        neighborhoodId: this.neighborhoodId,
        street: this.street,
        buildNumber: this.buildNumber,
        floorsCount: this.floorsCount,
        floorNumber: this.floorNumber,
        apartmentNumber: this.apartmentNumber,
        typeId: this.typeId,
        title: this.title,
        description: this.description,
        price: this.price,
        latitude: this.latitude,
        longitude: this.longitude,
        propertyType: this.propertyType,
        area: this.area,
        roomsCount: this.roomsCount,
        bathrooms: this.bathrooms,
        age: this.age,
        agentId: this.agentId,
        status: this.status,
        manageProperty: this.manageProperty,
        adDuration: this.adDuration,
        isFeatured: this.isFeatured,
        rejectionNote: this.rejectionNote,
        startDate: (this.startDate)? this.startDate : null,
        rentExpire: (this.rentExpire)? this.rentExpire : null,
        mediaIds: this.mediaIds,
        features: this.features,
        tenant: this.tenant,
        finalPrice: (this.finalPrice)? this.finalPrice : null,
        rentalTerm: (this.rentalTerm && this.rentalTerm != '')? this.rentalTerm : 0,
        rentalUnit: this.rentalUnit,
        commission: (this.commission)? parseFloat(this.commission) : 0,
        commissionCollected: this.commissionCollected,
        frontId: this.frontId,
        furnished: this.furnished,
        hasObligations: this.hasObligations,
        saudiBuildingCode: this.saudiBuildingCode,
        plotNumber: this.plotNumber,
        meterPrice: this.meterPrice,
        halls: this.halls,
        containerId: this.containerId,
        projectId: this.projectId,
        hasLawsuit: this.hasLawsuit,
        managementType: this.managementType,
        commissionType: this.commissionType,
      };
      const formData = new FormData();
      formData.append('property', JSON.stringify(property));
      formData.append('owner', JSON.stringify(owner));
      formData.append('payments', JSON.stringify(this.propertyPayments));
      if(this.receiptImage){
        for(let rf=0; rf<this.receiptImage.length; rf++){
          formData.append('receiptImage', this.receiptImage[rf]);
        }
      }
      if(this.agencyImage){
        for(let rf=0; rf<this.agencyImage.length; rf++){
          formData.append('agencyImage', this.agencyImage[rf]);
        }
      }
      formData.append('identityImage', this.identityImage);
      formData.append('buildingPermitImage', this.buildingPermitImage);
      formData.append('defenseCertificateImage', this.defenseCertificateImage);

      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/properties/update/${this.dataRow.id}`, formData);
      else
        api = this.$http.post('/api/admin/properties/create', formData);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعلان بنجاح', 'success');
          this.$router.replace('/properties').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          this.step = 1;
          this.collectedAmount = data.collectedAmount;
          this.remainingPayments = data.remainingPayments;
          if(data.receiptImage)
            this.uploadedReceipt = JSON.parse(data.receiptImage);
          if(data.agencyImage)
            this.uploadedAgencyImage = data.agencyImage;
          if(data.identityImage)
            this.uploadedIdentityImage = data.identityImage;
          if(data.buildingPermitImage)
            this.uploadedBuildingPermitImage = data.buildingPermitImage;
          if(data.defenseCertificateImage)
            this.uploadedDefenseCertificateImage = data.defenseCertificateImage;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    // google map 
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    changeMarker(){
      const newPosition = new google.maps.LatLng(this.latitude, this.longitude);
      this.marker.setPosition(newPosition);
      this.map.setCenter(newPosition);
    },
    changeMapMarker(){
      if(this.neighborhoodId){
        for(let i=0; i<this.neighborhoodsList.length; i++){
          if(this.neighborhoodsList[i].id == this.neighborhoodId){
            const lat = parseFloat(this.neighborhoodsList[i].latitude);
            const lng = parseFloat(this.neighborhoodsList[i].longitude);
            if(lat && lng){
              this.latitude = lat;
              this.longitude = lng;
              this.changeMarker();
            }
          }
        }
      }
    },
    jumbToStep(stepNum){
      if(this.dataRow){
        this.step = stepNum;
        if(stepNum == 3){
          this.initialGoogleMap();
          this.applySelect2Cities();
          this.applySelect2Neighborhoods();
          this.applySelect2Types();     
          this.applySelect2Fronts();
        }
      }
    },
    addPayment(){
      this.propertyPayments.push({
        id: null,
        amount: 0,
        dueDate: '',
        isPaid: false,
        paymentDate: '',
      });
    },
    removePayment(indx){
      this.propertyPayments.splice(indx, 1);
    },
    setIdentityImage(files){
      this.identityImage = files[0];
    },
    setBuildingPermitImage(files){
      this.buildingPermitImage = files[0];
    },
    setDefenseCertificateImage(files){
      this.defenseCertificateImage = files[0];
    },
    setTypeFields(){
      this.currentTypeFields = [];
      for(let i=0; i<this.typesList.length; i++){
        if(this.typesList[i].id == this.typeId)
          this.currentTypeFields = this.typesList[i].propertyFields ?? [];
      }
    },
    setTypesList(){
      this.typesList = [];
      if(this.category){
        for(let i=0; i<this.typesListOriginal.length; i++){
          if(this.typesListOriginal[i].category == this.category){
            this.typesList.push(this.typesListOriginal[i]);
          }
        }
      }
      this.setTypeFields();
      this.$nextTick(() => {
        this.applySelect2Types();
      });
    },
    checkAdLicense(){
      this.regaValidateLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      if(!this.validatorIdType || !this.validatorAdLicenseNumber || !this.validatorAdvertiserId){
        this.message = 'كل البيانات مطلوبة';
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.regaValidateLoader = false;
        return;
      }

      this.$http.post(`/api/admin/properties/checkAd/${this.dataRow.id}`, {
        idType: this.validatorIdType,
        adLicenseNumber: this.validatorAdLicenseNumber,
        advertiserId: this.validatorAdvertiserId,
      }).then(({data}) => {
        this.regaAdValidator = data.result;
        this.regaValidateLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.regaValidateLoader = false;
      });
    },
    validateCoupon(){
      if(!this.couponCode || !this.dataRow){
        if(!this.dataRow){
          this.couponResult = { status: 'info', msg: 'يمكن التحقق من الكوبون بعد حفظ العقار أولاً' };
          return;
        }
      }
      if(!this.couponCode) return;
      this.couponLoading = true;
      this.couponResult = null;
      const propertyId = this.dataRow ? this.dataRow.id : null;
      if(!propertyId){
        this.couponResult = { status: 'fail', msg: 'يجب حفظ العقار أولاً للتحقق من الكوبون' };
        this.couponLoading = false;
        return;
      }
      this.$http.post('/api/admin/coupons/checkProperty', {coupon: this.couponCode, propertyId: propertyId }).then(({data}) => {
        this.couponResult = data;
        this.couponLoading = false;
      }).catch(err => {
        const [msg] = this.$globalError(err, true);
        this.couponResult = { status: 'fail', msg: msg };
        this.couponLoading = false;
      });
    },
    applyFormSelect2(){
      this.applySelect2Projects();
      this.applySelect2Cities();
      this.applySelect2Neighborhoods();
      this.applySelect2Types();
      this.applySelect2Fronts();
    },
    applySelect2Field(refName, value, onChange){
      this.$nextTick(() => {
        if(this._select2Disposed || !this.$refs[refName]) return;
        const $el = $(this.$refs[refName]);
        if(!$el.hasClass('select2-hidden-accessible')){
          $el.select2({ width: '100%', dir: 'rtl' });
        }
        $el.off(`change.${refName}2`);
        const emptyOption = Array.from($el[0].options).find(option => option.value === '' || (Object.hasOwn(option, '_value') && option._value == null));
        $el.val(value == null || value === '' ? (emptyOption ? emptyOption.value : null) : value).trigger('change.select2');
        $el.on(`change.${refName}2`, function(){
          const selected = Number($(this).val());
          onChange(Number.isSafeInteger(selected) && selected > 0 ? selected : null);
        });
      });
    },
    destroyFormSelect2(){
      ['projectsSelect', 'citiesSelect', 'neighborhoodsSelect', 'typesSelect', 'frontsSelect'].forEach(refName => {
        const $el = $(this.$refs[refName]);
        $el.off(`change.${refName}2`);
        if($el.hasClass('select2-hidden-accessible')) $el.select2('destroy');
      });
    },
    applySelect2Projects(){
      this.applySelect2Field('projectsSelect', this.projectId, value => {
        if(this.containerId || this.projectId == value) return;
        this.projectId = value;
        this.setProject();
      });
    },
    applySelect2Cities(){
      this.applySelect2Field('citiesSelect', this.cityId, value => {
        if(this.cityId == value) return;
        this.cityId = value;
        this.getNeighborhoodsList();
      });
    },
    applySelect2Neighborhoods(){
      this.applySelect2Field('neighborhoodsSelect', this.neighborhoodId, value => {
        if(this.neighborhoodId == value) return;
        this.neighborhoodId = value;
        this.changeMapMarker();
      });
    },
    applySelect2Types(){
      this.applySelect2Field('typesSelect', this.typeId, value => {
        if(this.typeId == value) return;
        this.typeId = value;
        this.setTypeFields();
      });
    },
    applySelect2Fronts(){
      this.applySelect2Field('frontsSelect', this.frontId, value => {
        this.frontId = value;
      });
    },
  },
  created(){
    if(this.dataRow || this.copyFromData){
      // for config
      const src = this.dataRow ?? this.copyFromData;
      this.userMobile = src.PropertyOwner.User.mobile;
      this.userName = src.PropertyOwner.User.name;
      this.uploadedReceipt = src.PropertyOwner.receiptImage;
      this.uploadedAgencyImage = src.PropertyOwner.agencyImage;
      this.uploadedIdentityImage = src.PropertyOwner.identityImage;
      this.uploadedBuildingPermitImage = src.PropertyOwner.buildingPermitImage;
      this.uploadedDefenseCertificateImage = src.PropertyOwner.defenseCertificateImage;
      if(this.dataRow){
        if(this.dataRow.mediaFiles){
          this.dataRow.mediaFiles.map(m => {
            this.mediaList.push({
              id: m.id,
              path: m.filePath,
            });
            this.mediaIds.push(m.id);
          });
        }
        this.createdBy = (this.dataRow.Admin)? this.dataRow.Admin.name : null;
        if(this.dataRow.User){
          this.rentalMobile = this.dataRow.User.mobile;
          this.rentalName = this.dataRow.User.name;
        }
        this.tenant = this.dataRow.tenant;
        this.finalPrice = this.dataRow.finalPrice;
        this.collectedAmount = this.dataRow.collectedAmount;
        this.remainingPayments = this.dataRow.remainingPayments;
        this.rentalTerm = this.dataRow.rentalTerm;
        this.rentalUnit = this.dataRow.rentalUnit;
        this.featuredAmount = this.dataRow.featuredAmount;
        this.commission = (this.dataRow.commission)? parseFloat(this.dataRow.commission) : 0;
        this.commissionCollected = this.dataRow.commissionCollected;
        this.isPayed = this.dataRow.isPayed;
        this.commissionType = this.dataRow.commissionType || 'percent';
        // this.propertyPayments = this.dataRow.PropertyPayments ?? [];
        if(this.dataRow.PropertyPayments){
          this.dataRow.PropertyPayments.map(pay => {
            this.propertyPayments.push({
              id: pay.id,
              amount: pay.amount,
              dueDate: (pay.dueDate)? shortDate(pay.dueDate) : null,
              isPaid: pay.isPaid,
              paymentDate: (pay.paymentDate)? shortDate(pay.paymentDate) : null,
            });
          });
        }
        if(this.dataRow.AdValidator){
          this.regaAdValidator = this.dataRow.AdValidator;
          this.validatorIdType = this.dataRow.AdValidator.idType;
          this.validatorAdLicenseNumber = this.dataRow.AdValidator.adLicenseNumber;
          this.validatorAdvertiserId = this.dataRow.AdValidator.advertiserId;
        }
      }
      // for form owner
      this.userId = src.PropertyOwner.userId;
      this.ownerType = src.PropertyOwner.ownerType;
      this.receiptNumber = src.PropertyOwner.receiptNumber;
      // this.receiptDate = (src.PropertyOwner.receiptDate)? shortDate(src.PropertyOwner.receiptDate) : null;
      this.ownerIdentity = src.PropertyOwner.ownerIdentity;
      this.ownerDOB = (src.PropertyOwner.ownerDOB)? shortDate(src.PropertyOwner.ownerDOB) : null;
      this.ownerMobile = src.PropertyOwner.ownerMobile;
      this.agentIdentity = src.PropertyOwner.agentIdentity;
      this.agencyNumber = src.PropertyOwner.agencyNumber;
      this.agencyDate = (src.PropertyOwner.agencyDate)? shortDate(src.PropertyOwner.agencyDate) : null;
      // this.agentDOB = (src.PropertyOwner.agentDOB)? shortDate(src.PropertyOwner.agentDOB) : null;
      this.agentMobile = (src.PropertyOwner.agentMobile)? src.PropertyOwner.agentMobile : null;
      this.falLicense = src.PropertyOwner.falLicense;
      this.adLicenseNumber = src.PropertyOwner.adLicenseNumber;
      // for property form
      this.category = src.category;
      this.purpose = src.purpose;
      this.regionId = src.regionId;
      this.cityId = src.cityId;
      this.neighborhoodId = src.neighborhoodId;
      this.street = src.street;
      this.buildNumber = src.buildNumber;
      this.floorsCount = src.floorsCount;
      this.floorNumber = src.floorNumber;
      this.apartmentNumber = src.apartmentNumber;
      this.typeId = src.typeId;
      this.title = src.title;
      this.description = src.description;
      this.price = src.price;
      this.latitude = (src.latitude)? parseFloat(src.latitude) : null;
      this.longitude = (src.longitude)? parseFloat(src.longitude) : null;
      this.propertyType = src.propertyType;
      this.area = src.area;
      this.roomsCount = src.roomsCount;
      this.bathrooms = src.bathrooms;
      this.age = src.age;
      this.agentId = src.agentId;
      this.status = src.status;
      this.manageProperty = src.manageProperty;
      this.adDuration = src.adDuration;
      this.isFeatured = src.isFeatured;
      this.rejectionNote = src.rejectionNote;
      this.startDate = (src.startDate)? shortDate(src.startDate) : null;
      this.rentExpire = (src.rentExpire)? shortDate(src.rentExpire) : null;
      this.crmChat = src.PropertyOwner.crmChat === true;
      if(src.PropertyFeatures){
        src.PropertyFeatures.map(f => {
          this.features.push(f.id);
        })
      }
      this.frontId = src.frontId;
      this.furnished = src.furnished;
      this.hasObligations = src.hasObligations;
      this.saudiBuildingCode = src.saudiBuildingCode;
      this.plotNumber = src.plotNumber;
      this.meterPrice = src.meterPrice;
      this.halls = src.halls;
      this.containerId = src.containerId ?? null;
      this.projectId = src.projectId || src.PropertyContainer?.projectId || null;
      this.getCitiesList(false);
      this.getNeighborhoodsList(false);
      this.hasLawsuit = src.hasLawsuit ?? false;
      this.managementType = src.managementType ?? null;
      // this.setTypeFields();
    }

    if(this.currentUserContainers && this.currentUserContainers.length)
      this.containers = this.currentUserContainers;
    
    // this.applySelect2Cities();
    // this.applySelect2Neighborhoods();
    // this.applySelect2Types();     
    // this.applySelect2Fronts();
    this.getInitData();
  },
}
</script>

<style scoped>
.steps-container {
  margin-bottom: 40px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 8px;
}
.steps-container > .col { min-width: max-content; }
.steps {
  display: flex;
  justify-content: space-around;
  white-space: nowrap;
  font-weight: bold;
  cursor: pointer;
}

.steps span {
  padding: 5px 15px;
  border-bottom: 3px solid #ccc;
}

.steps .active {
  color: #007bff;
  border-bottom: 3px solid #007bff;
}
#validatorForm fieldset {
  border: 1px solid #DDD;
  border-radius: 5px;
  padding: 10px;
}
#validatorForm legend {
  font-size: 18px;
}
#validatorForm .set-padding {
  padding-top: 35px;;
}
.steps .marketing-step.active {
  color: #176548;
  border-bottom-color: #176548;
}
.marketing-step-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 4px;
  border-radius: 50%;
  color: #fff;
  background: #176548;
  font-size: 11px;
}
</style>